import Axios from "axios";

/** POST conference visitor registration reception actions. */
export const postConferenceVisitorCheckIn = (visitorRegistrationId: number) =>
  Axios.post(`/booking/conference-visitor-registrations/${visitorRegistrationId}/check-in`);

export const postConferenceVisitorCheckOut = (visitorRegistrationId: number) =>
  Axios.post(`/booking/conference-visitor-registrations/${visitorRegistrationId}/check-out`);

export const postConferenceVisitorReject = (
  visitorRegistrationId: number,
  body?: { reason?: string }
) => Axios.post(`/booking/conference-visitor-registrations/${visitorRegistrationId}/reject`, body);
